import ThemePageModal from '../../themes/Theme.Page.Modal';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';

const ThemeModalDefault: Component.Modal.Import['subcomponents'] = {
  page: { class: ThemePageModal },
  closeButton: { class: ThemeButtonCircle },
};
export default ThemeModalDefault;
